import { Pipe, PipeTransform } from '@angular/core';
import { ForceAny } from '../typescript';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(items: ForceAny[], property: string, value: ForceAny = true) {
    if (!items || !property) {
      return items;
    }
    // Filter items where the property equals the value
    return items.filter((item) => item[property] === value || !item[property]);
  }
}
